export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <p>
          Migration Risk Reviewer — parte del portafolio de{' '}
          <a href="https://alexcuesta.dev" target="_blank" rel="noreferrer">
            alexcuesta.dev
          </a>
          . Código en{' '}
          <a
            href="https://github.com/Aredex/migration-risk-reviewer"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          .
        </p>
      </div>
    </footer>
  )
}
